module.exports = __webpack_public_path__ + "static/gallery18-7a88fe1e9e1a7cef547c31920ae35f9b.jpg";